import React, { useEffect, useState, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as courseLandingPageAPI from "../../../../../actions/content/courseLandingPages";
import config from "../../../../../config/config";
import { resetViewToTopOfPage } from "../../../../../utils/utils";
import stateConfig from "../../../../../config/state";
import useAnalytics from "../../../../../hooks/useAnalytics";
import validator from "../../../../../utils/validator";
import CourseLandingPageSectionHeader from "./CourseLandingPageSectionHeader";
import LoadingMessage from "../../../../common/messages/LoadingMessage";
import NotFoundContent from "../../../../NotFoundContent";
import CourseLandingPageSectionMain from "./CourseLandingPageSectionMain";
const { isNotEmpty } = validator;

function CourseLandingPage({ courseLandingPage, courseLandingPageAPI }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [slug, setSlug] = useState(null);
  const stateId = `${stateConfig.keys.COURSE_LANDING_PAGE}`;

  useAnalytics("Course Landing Page");
  // defining fns used in useEffect blocks
  let initialize = config.emptyFn;

  useEffect(() => {
    initialize();
  }, [initialize]);

  useEffect(() => {
    if(loading && courseLandingPage.ids && Boolean(slug)) {
      const rObj = courseLandingPage.byId[`${stateId}.${slug}`];

      if(rObj) {
        if(!rObj || rObj.error) {
          setLoading(false);
          setError(rObj.error);
        } else {
          setLoading(false);
          setData(rObj);
        }
      }
    }
  }, [loading, slug, courseLandingPage.ids, courseLandingPage.byId, stateId])

  initialize = () => {
    resetViewToTopOfPage();
    const slug = window.location.pathname.replace("/landing/", "");
    setSlug(slug);
    retrieveCourseLandingPage(slug);
  }

  const retrieveCourseLandingPage = (slug) => {
    const { byId } = courseLandingPage;
    const rObj = byId[`${stateId}.${slug}`];

    if(rObj && !validator.isDefined(rObj.error)) {
      setData(rObj);
      setLoading(false);
    } else {
      courseLandingPageAPI.getCourseLandingPageBySlug(slug);
    }
  }

  return (
    <Fragment>
      { loading && 
        <div className="CourseLandingPage-loading">
          <LoadingMessage message="Loading..." /> 
        </div>
      }

      {/* testing for any error.code instead of specific error to account for changes in the error response format */}
      { !loading && isNotEmpty(error) && error.code && 
        <div className="CourseLandingPage-loading">
          <NotFoundContent />
        </div>
      }

      { !loading && data &&
        <div className="CourseLandingPage" landing-page-theme={data ? data.colorTheme : "blue"}>          
          <CourseLandingPageSectionHeader data={data} />
          <CourseLandingPageSectionMain data={data} />
        </div>
      }
    </Fragment>
  )
}

function mapStateToProps(state) {
  return { courseLandingPage: state.courseLandingPage };
}

function mapDispatchToProps(dispatch) {
  return {
    courseLandingPageAPI: bindActionCreators(courseLandingPageAPI, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CourseLandingPage);